import lottie from 'lottie-web'
import inView from 'in-view';

export default class Animation {
    constructor() {
        let animations = document.querySelectorAll('[data-animation]');
        this.lottieAnimations = [];

        for (let i = 0; i < animations.length; i++) {
            let container = animations[i];
            let file = container.dataset.animation;
            let loop = container.dataset.loop === 'true' ? true : false;
            let autoplay = container.dataset.autoplay === 'true' ? true : false;


           this.lottieAnimations[i] = lottie.loadAnimation({
                container: animations[i],
                renderer: 'svg',
                path: file,
                name: 'animation-' + i,
                loop: loop,
                autoplay: true,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMax meet'
                }
            });
        }
    }
}
